import React, { useState } from 'react';
import debounce from 'lodash/debounce';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles, TextField } from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Clear } from '@material-ui/icons';
import addButton from './Add.svg';
import ClaimDateField from './ClaimDateField';
import {
  setConnectingFlightsDraft,
  setProblemsDraft,
  setClaimDraft
} from '../../actions/claimAction';
import { CStandardInput } from '../../component/Input';
import Garbage from '../../asset/garbage.svg';
import AIRLINES from '../../constant/airlines';
import camelCaseToTitleCase from '../../helpers/camelCaseToTitleCase';
import { searchAirports } from '../../services/napi';
import { AutocompleteSelect, MultipleSelect } from '../../component/Select';

const useStyles = makeStyles({
  autocomplete: {
    ' & .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '8px 14px',
      width: '315px'
    },
    '& .MuiInput-underline:after': {
      display: 'none'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      textAlign: 'start',
      top: '-7px',
      width: 'fit-content',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  autocompleteRed: {
    ' & .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'red',
      margin: '0px',
      padding: '8px 14px',
      width: '315px'
    },
    '& .MuiInput-underline:after': {
      display: 'none'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      textAlign: 'start',
      top: '-7px',
      width: 'fit-content',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  chip: {
    '& .MuiChip-deleteIcon': {
      // color: '#5564F8',
      transform: 'translateY(5px)'
    },
    '& div': {
      display: 'block'
    },
    alignItems: 'center',
    display: 'flex',
    margin: '',
    width: '100%'
  },
  connectingAirportDeleteButton: {
    cursor: 'pointer',
    fontSize: '18px',
    marginLeft: '6px',
    transform: 'translateY(6px)'
  },
  connectingAirports: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  date: {
    transform: 'translate(-28px, -10px) scale(0.83)'
  },
  delay: {
    alignItems: 'center',
    borderBottom: '1px solid #CAD8FF',
    display: 'flex',
    fontSize: '12px',
    height: '25%',
    justifyContent: 'flex-start',
    padding: '18px 12px',
    width: '100%'
  },
  delayAmount: {
    height: '100%'
  },
  disableRoot: {
    ' & .MuiInputBase-root': {
      background: '#CAD8FF',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: '#5564F8',
      margin: '0px',
      padding: '14px 16px',
      width: '315px'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },

    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      top: '-7px',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  dropdownPhone: {
    marginRight: '10px',
    transform: 'translateY(-5px)',
    width: '85px'
  },
  garbage: {
    '& img': {
      cursor: 'pointer',
      maxWidth: '30px'
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '315px'
  },
  gridContainer: {
    alignItems: 'space-between',
    display: 'grid',
    gridRowGap: '35px',
    gridTemplateColumns: '315px 315px',
    height: '100%',
    justifyContent: 'space-between',
    width: '100%'
  },
  gridItem: {
    width: '315px'
  },
  gridItemButton: {
    alignItems: 'center',
    background: 'transparent',
    border: '1px solid #CAD8FF',
    borderRadius: '10px',
    color: '#5564F8',
    cursor: 'pointer',
    display: 'flex',
    fontSize: '12px',
    height: '40px',
    justifyContent: 'center',
    userSelect: 'none'
  },
  gridItemDate: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%'
  },
  gridItemDelay: {
    background: 'white',
    borderRadius: '10px',
    gridRow: '6 / 11'
  },
  mainDiv: {
    background: '#F0F4FF',
    borderRadius: '10px',
    margin: '30px 40px 0px 35px',
    padding: '40px 135px'
  },
  phoneWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '320px'
  },
  root: {
    ' & .MuiInputBase-root': {
      background: 'white',
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px',
      width: '315px'
    },
    '& .MuiInput-inputMultiline': {
      alignItems: 'flex-start',
      height: '110px'
    },
    '& .MuiInput-underline:after': {
      display: 'none'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },

    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    },
    '& .MuiInputLabel-formControl': {
      fontFamily: 'Poppins',
      fontSize: '12px',
      left: '13px',
      textAlign: 'start',
      top: '-7px',
      width: 'fit-content',
      zIndex: '1'
    },
    '& .MuiInputLabel-shrink': {
      color: '#9BA0AD',
      transform: 'translate(-15px, -13px) scale(0.83)',
      transformOrigin: 'top left'
    }
  },
  selectHeader: {
    color: '#9BA0AD',
    fontFamily: 'Poppins',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    lineHeight: '100%',
    margin: '0px',
    textAlign: 'start',
    transform: 'translate(-30px, -15px) scale(0.83)'
  },
  selectHeaderPhone: {
    transform: 'translate(-10px, -10px) scale(0.83)'
  }
});

const FlightDetail = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [departureValue, setDepartureValue] = useState([]);
  const [arrivalValue, setArrivalValue] = useState([]);
  const [connectingValue1, setConnectingValue1] = useState([]);
  const [connectingValue2, setConnectingValue2] = useState([]);
  const [connectingValue3, setConnectingValue3] = useState([]);

  const claimDraft = useSelector(({ claims }) => claims.claimDraft);
  const selectedClaim = useSelector(({ claims }) => claims.selectedClaim);
  const connectingFlights = useSelector(({ claims }) => claims.connectingFlights);
  const problems = useSelector(({ claims }) => claims.problems);

  const sortAirlinesAlphabetically = AIRLINES.sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase())
  );
  const delayAmount = [
    'Less Then 3 Hours',
    'More Then 3 Hours',
    'Missed Connecting Flight',
    'The Flight Was Not Performed'
  ];

  const additionalCostsFor = ['hotelExpenses', 'ticketExpenses', 'other'];

  const onChangeHandler = (type, data) => {
    dispatch(
      setClaimDraft({
        ...claimDraft,
        [type]: data
      })
    );
  };

  const onAirportSearch = (value, type) => {
    debounce(async () => {
      const response = await searchAirports(value);
      switch (type) {
        case 'departure':
          setDepartureValue(response.data.airports);
          break;
        case 'arrival':
          setArrivalValue(response.data.airports);
          break;
        case 'connecting1':
          setConnectingValue1(response.data.airports);
          break;
        case 'connecting2':
          setConnectingValue2(response.data.airports);
          break;
        case 'connecting3':
          setConnectingValue3(response.data.airports);
          break;
        default:
          break;
      }
    }, 500)();
  };

  const handleChange = (value, type) => {
    if (value.length < 2) return;
    onAirportSearch(value, type);
  };

  const ChipsTextElement = () => {
    const [chips, setChips] = useState(claimDraft.incidentFlightNumbers || []);

    const handleAddChip = (chip) => {
      setChips((prev) => {
        const updatedChips = [...prev, chip];
        onChangeHandler('incidentFlightNumbers', updatedChips);
        return updatedChips;
      });
    };
    const handleDeleteChip = (chip) => {
      setChips(() => {
        const filteredChips = chips.filter((item) => item !== chip);
        onChangeHandler('incidentFlightNumbers', filteredChips);
        return filteredChips;
      });
    };

    return (
      <ChipInput
        classes={{ root: classes.chip }}
        disableUnderline
        fullWidth
        InputProps={{
          inputProps: {
            style: {
              background: 'white',
              border: '1px solid #CAD8FF',
              borderRadius: '12px',
              color: 'black',
              margin: '0px',
              padding: '11.625px 15px',
              width: '285px'
            }
          }
        }}
        newChipKeys={['Enter', ' ', 'Tab']}
        onAdd={(chip) => handleAddChip(chip)}
        onDelete={(chip) => handleDeleteChip(chip)}
        placeholder="The flight number where the problem occurred"
        value={chips}
      />
    );
  };

  return (
    <div className={classes.mainDiv}>
      <div className={classes.gridContainer}>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-name"
            id="standard-input-claim-detail-name"
            // defaultValue={selectedClaim.ticketNumber || ''}
            label="Ticket Number"
            onChange={(e) => onChangeHandler('ticketNumber', e.target.value)}
            size="large"
            value={claimDraft.ticketNumber}
          />
        </div>
        <div className={classes.gridItem}>
          <ChipsTextElement value={claimDraft.incidentFlightNumbers || []} />
        </div>
        <div className={classes.gridItem}>
          <p className={classes.selectHeader}>Airline Name</p>
          <AutocompleteSelect
            getOptionLabel={(option) => option}
            id="autocomplete-flight-detail-airline-name"
            onSelect={(airline) => onChangeHandler('airlineName', airline)}
            options={sortAirlinesAlphabetically}
            placeholderValue={claimDraft.airlineName || ''}
          />
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-id-number"
            id="standard-input-claim-detail-id-number"
            // defaultValue={camelCaseToTitleCase(problems.toString()) || ""}
            label="Problems"
            onChange={(e) => dispatch(setProblemsDraft(e.target.value))}
            size="large"
            value={camelCaseToTitleCase(problems.toString())}
          />
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-id-number"
            id="standard-input-claim-detail-id-number"
            // defaultValue={selectedClaim.flightNumber || ""}
            label="First Leg Flight Number"
            onChange={(e) => onChangeHandler('flightNumber', e.target.value)}
            size="large"
            value={claimDraft.flightNumber}
          />
        </div>

        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-id-number"
            id="standard-input-claim-detail-id-number"
            // defaultValue={selectedClaim.problemDescription || ""}
            label="Describe problem"
            onChange={(e) => onChangeHandler('problemDescription', e.target.value)}
            size="large"
            value={claimDraft.problemDescription}
          />
        </div>

        {problems.length && !problems?.toLowerCase()?.includes('other') ? (
          <div className={classes.gridItem} />
        ) : null}

        <div>
          <div className={`${classes.selectHeader} ${classes.date}`}>
            Enter departure time specified in the ticket
          </div>
          <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
            <ClaimDateField
              claimDate={selectedClaim.ticketDepartureDate}
              type="ticketDepartureDate"
              value={claimDraft.ticketDepartureDate}
            />
          </div>
        </div>

        <div>
          <div className={`${classes.selectHeader} ${classes.date}`}>
            Enter actual time of departure
          </div>
          <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
            <ClaimDateField
              claimDate={selectedClaim.actualDepartureDate}
              type="actualDepartureDate"
              value={claimDraft.actualDepartureDate}
            />
          </div>
        </div>

        <div>
          <div className={`${classes.selectHeader} ${classes.date}`}>
            Enter arrival time specified in the ticket
          </div>
          <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
            <ClaimDateField
              claimDate={selectedClaim.ticketArrivalDate}
              type="ticketArrivalDate"
              value={claimDraft.ticketArrivalDate}
            />
          </div>
        </div>

        <div>
          <div className={`${classes.selectHeader} ${classes.date}`}>
            Enter actual time of arrival
          </div>
          <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
            <ClaimDateField
              claimDate={selectedClaim.actualArrivalDate}
              type="actualArrivalDate"
              value={claimDraft.actualArrivalDate}
            />
          </div>
        </div>

        <div>
          <div className={`${classes.selectHeader} ${classes.date}`}>Number of Delayed Hours</div>
          <div className={`${classes.gridItem} ${classes.gridItemDelay}`}>
            {delayAmount.map((delay, index) => {
              return (
                <div
                  key={delay}
                  className={classes.delay}
                  style={index === delayAmount.length - 1 ? { borderBottom: 'unset' } : {}}
                >
                  <input
                    defaultChecked={delay === claimDraft.delayedHours}
                    id={`radio button ${index}`}
                    name="delay"
                    onChange={() => {
                      return dispatch(
                        setClaimDraft({
                          ...claimDraft,
                          delayedHours: delay
                        })
                      );
                    }}
                    style={{ marginRight: '10px' }}
                    type="radio"
                  />
                  <label htmlFor={`radio button ${index}`}>{delay}</label>
                </div>
              );
            })}
          </div>
        </div>

        <div className={classes.gridItem} />

        {connectingFlights?.map((flight, index) => {
          return (
            <>
              <div key={index} className={classes.gridItem}>
                <CStandardInput
                  disableUnderline
                  formclasses={{ root: classes.root }}
                  htmlFor="standard-input-claim-detail-passport"
                  id="standard-input-claim-detail-passport"
                  label="Connecting Flight Number"
                  onChange={(event) => {
                    connectingFlights[index] = {
                      ...connectingFlights[index],
                      flightNumber: event.target.value
                    };
                    dispatch(setConnectingFlightsDraft([...connectingFlights]));
                  }}
                  size="large"
                  value={flight.flightNumber}
                />
              </div>

              <div key={`${index}a`} className={classes.garbage}>
                <img
                  alt="delete connecting flight"
                  onClick={() => {
                    connectingFlights.splice(index, 1);
                    dispatch(setConnectingFlightsDraft([...connectingFlights]));
                  }}
                  src={Garbage}
                />
              </div>

              <div key={`${index}c`}>
                <div className={`${classes.selectHeader} ${classes.date}`}>
                  Enter departure time specified by connecting airport
                </div>
                <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
                  <ClaimDateField
                    claimDate={flight?.departure ?? ''}
                    index={index}
                    type="connectingArrivalTime"
                    value={flight.connectingArrivalTime}
                  />
                </div>
              </div>

              <div key={`${index}b`}>
                <div className={`${classes.selectHeader} ${classes.date}`}>
                  Enter actual time of arrival at the connecting airport
                </div>
                <div className={`${classes.gridItem} ${classes.gridItemDate}`}>
                  <ClaimDateField
                    claimDate={flight?.arrival ?? ''}
                    index={index}
                    type="actualConnectingArrivalTime"
                    value={flight.actualConnectingArrivalTime}
                  />
                </div>
              </div>
            </>
          );
        })}

        <div
          className={`${classes.gridItem} ${classes.gridItemButton}`}
          onClick={() => {
            dispatch(setConnectingFlightsDraft([...connectingFlights, {}]));
          }}
        >
          <img
            alt="add another connecting flight"
            src={addButton}
            style={{ marginRight: '10px' }}
          />
          Add an other connecting flight
        </div>

        <div className={classes.gridItem} />

        <div className={classes.gridItem}>
          <Autocomplete
            defaultValue={{ name: claimDraft.departureAirport.name }}
            freeSolo
            getOptionLabel={(option) => option.name}
            id="autocomplete-departure-airport"
            onChange={(event, newValue) => {
              if (newValue) {
                if (claimDraft.incidentAirportIds?.includes(claimDraft.departureAirportId)) {
                  claimDraft.incidentAirportIds[
                    claimDraft.incidentAirportIds.indexOf(claimDraft.departureAirportId)
                  ] = newValue._id;
                  dispatch(
                    setClaimDraft({
                      ...claimDraft,
                      incidentAirportIds: claimDraft.incidentAirportIds
                    })
                  );
                }
                dispatch(
                  setClaimDraft({
                    ...claimDraft,
                    departureAirportId: newValue._id
                  })
                );
              }
            }}
            options={departureValue}
            renderInput={(params) => (
              <TextField
                {...params}
                // classes={{ root: classes.autocomplete }}
                classes={
                  selectedClaim.incidentAirports?.some(
                    (e) => e.name === claimDraft.departureAirport?.name
                  )
                    ? { root: classes.autocompleteRed }
                    : { root: classes.autocomplete }
                }
                defaultValue={claimDraft.departureAirport.name}
                label="Departure Airport"
                onChange={(e) => handleChange(e.target.value, 'departure')}
              />
            )}
            spellCheck
            style={{ height: '30px' }}
          />
        </div>

        <div className={classes.gridItem}>
          <Autocomplete
            defaultValue={{ name: claimDraft.arrivalAirport.name }}
            freeSolo
            getOptionLabel={(option) => option.name}
            id="autocomplete-arrival-airport"
            onChange={(event, newValue) => {
              if (newValue) {
                dispatch(
                  setClaimDraft({
                    ...claimDraft,
                    arrivalAirportId: newValue._id
                  })
                );
              }
            }}
            options={arrivalValue}
            renderInput={(params) => (
              <TextField
                {...params}
                classes={{ root: classes.autocomplete }}
                label="Arrival Airport"
                onChange={(e) => handleChange(e.target.value, 'arrival')}
                value={claimDraft.arrivalAirport.name}
              />
            )}
            style={{ height: '30px' }}
          />
        </div>
        {claimDraft.transferAirports
          ? claimDraft.transferAirports.map((airport, index) => {
              let option = [];
              switch (index) {
                case 0:
                  option = connectingValue1;
                  break;
                case 1:
                  option = connectingValue2;
                  break;
                case 2:
                  option = connectingValue3;
                  break;
                default:
                  break;
              }
              return (
                <div key={index} className={`${classes.gridItem} ${classes.connectingAirports} `}>
                  <Autocomplete
                    defaultValue={{ name: airport?.name ?? '' }}
                    freeSolo
                    getOptionLabel={(option) => option.name}
                    id={`autocomplete-connecting-airport-${index + 1}`}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        if (claimDraft.incidentAirportIds?.includes(airport._id)) {
                          claimDraft.incidentAirportIds[
                            claimDraft.incidentAirportIds.indexOf(airport._id)
                          ] = newValue._id;
                          dispatch(
                            setClaimDraft({
                              ...claimDraft,
                              incidentAirportIds: claimDraft.incidentAirportIds
                            })
                          );
                        }
                        claimDraft.transferAirportIds[index] = newValue._id;
                        dispatch(
                          setClaimDraft({
                            ...claimDraft,
                            transferAirportIds: [...claimDraft.transferAirportIds]
                          })
                        );
                      }
                    }}
                    options={option}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        classes={
                          selectedClaim.incidentAirports?.some((e) => e.name === airport.name)
                            ? { root: classes.autocompleteRed }
                            : { root: classes.autocomplete }
                        }
                        label={`Connecting Airport ${index + 1}`}
                        onChange={(e) => handleChange(e.target.value, `connecting${index + 1}`)}
                        value={airport?.name ?? ''}
                      />
                    )}
                    style={{ height: '30px' }}
                  />
                  <Clear
                    className={classes.connectingAirportDeleteButton}
                    onClick={() => {
                      if (claimDraft.incidentAirportIds?.includes(airport._id)) {
                        claimDraft.incidentAirportIds.splice(
                          claimDraft.incidentAirportIds.indexOf(airport._id),
                          1
                        );
                        dispatch(
                          setClaimDraft({
                            ...claimDraft,
                            incidentAirportIds: claimDraft.incidentAirportIds
                          })
                        );
                      }
                      const transferAirports = [...claimDraft.transferAirports];
                      const transferAirportIds = [...claimDraft.transferAirportIds];
                      transferAirportIds.splice(
                        claimDraft.transferAirportIds.indexOf(airport._id),
                        1
                      );
                      transferAirports.splice(
                        claimDraft.transferAirports
                          .map((transferAirport) => transferAirport._id)
                          .indexOf(airport._id),
                        1
                      );
                      dispatch(
                        setClaimDraft({
                          ...claimDraft,
                          transferAirportIds: [],
                          transferAirports: []
                        })
                      );
                      setTimeout(() => {
                        dispatch(
                          setClaimDraft({
                            ...claimDraft,
                            transferAirportIds: [...transferAirportIds],
                            transferAirports: [...transferAirports]
                          })
                        );
                      }, 10);
                    }}
                  />
                </div>
              );
            })
          : null}
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-arrival-airport"
            id="standard-input-claim-detail-arrival-airport"
            label="Flight Distance"
            onChange={(e) => onChangeHandler('flightDistance', parseInt(e.target.value, 10))}
            size="large"
            value={claimDraft.flightDistance || ''}
          />
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-arrival-airport"
            id="standard-input-claim-detail-arrival-airport"
            label="Compensation Amount"
            onChange={(e) => onChangeHandler('compensationAmount', parseInt(e.target.value, 10))}
            // defaultValue={`${selectedClaim.compensationAmount} $` || ""}
            size="large"
            value={`${claimDraft.compensationAmount} €` || 0}
          />
        </div>
        <div className={classes.gridItem}>
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-arrival-airport"
            id="standard-input-claim-detail-arrival-airport"
            label="Companion count"
            // defaultValue={claimDraft.companionCount || 0}
            onChange={(e) => onChangeHandler('companionCount', parseInt(e.target.value, 10))}
            size="large"
            value={claimDraft.companionCount || 0}
          />
        </div>
        <div className={classes.gridItem}>
          <div className={`${classes.selectHeader} ${classes.date}`}>Enter Additional Costs</div>
          <MultipleSelect
            currentValue={claimDraft.additionalCosts || []}
            handleChange={(value) => {
              dispatch(
                setClaimDraft({
                  ...claimDraft,
                  additionalCosts: typeof value === 'string' ? value.split(',') : value
                })
              );
            }}
            selectOptions={additionalCostsFor}
            styles={{ textAlign: 'start' }}
            type="text"
          />
        </div>
        {claimDraft.additionalCosts?.includes('other') ? (
          <div className={classes.gridItem} />
        ) : null}
        {claimDraft.additionalCosts?.includes('other') ? (
          <CStandardInput
            disableUnderline
            formclasses={{ root: classes.root }}
            htmlFor="standard-input-claim-detail-arrival-airport"
            id="standard-input-claim-detail-arrival-airport"
            label="Additional Costs For Description Amount"
            onChange={(e) => onChangeHandler('additionalCostDescription', e.target.value)}
            // defaultValue={`${selectedClaim.compensationAmount} $` || ""}
            size="large"
            value={claimDraft.additionalCostDescription || ''}
          />
        ) : null}
      </div>
    </div>
  );
};

export default FlightDetail;
